import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageDropdown = () => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const toggleDropdown = () => setOpen(!open);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentLanguage = i18n.language.toLowerCase();

  
  return (
    <div className="dropdown gg-dropdown-lang" ref={dropdownRef}>
      <button
        className="btn btn-secondary dropdown-toggle gg-btn-dropdown-lang"
        onClick={toggleDropdown}
        aria-expanded={open}
      >
        {t(currentLanguage)}
      </button>
      <ul className={`dropdown-menu ${open ? 'show' : ''}`}>
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage('en')}>
            {t('en')}
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => changeLanguage('al')}>
            {t('al')}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default LanguageDropdown;
